// eslint-disable-line no-unused-expressions
import React from "react";
import { useSelector } from "react-redux";

import Backdrop from "../../../UI/Backdrop/Backdrop";
import InfoTable, { InfoRow } from "../InfoTable/InfoTable";

// The API leaves these flags out when it cannot determine them, so only a
// real boolean becomes Yes/No — anything else falls through to the em dash.
const booleanValue = (flag) => (typeof flag === "boolean" ? (flag ? "Yes" : "No") : null);

/*report: this variable belongs to the pdf page */
const APKInformationCard = ({ report = false }) => {
  const apkInfo = useSelector((state) => state.android.apkInfo);
  const apkInfoLoading = useSelector((state) => state.android.apkInfoLoading);

  return (
    <div className=" analysis-reports__body-block__information border">
      <Backdrop show={apkInfoLoading} absolute={true} />
      {/* The report pages put the same text in their own section heading */}
      {!report && <h3 className="article">APK Information</h3>}
      <InfoTable>
        <InfoRow label="Application Name" value={apkInfo.name} />
        <InfoRow label="Package Name" value={apkInfo.package} mono={true} />
        <InfoRow label="Version Code" value={apkInfo.version_code} />
        <InfoRow label="Version Name" value={apkInfo.version_name} />
        <InfoRow label="Target Sdk Version" value={apkInfo.target_sdk} />
        <InfoRow label="Min Sdk Version" value={apkInfo.min_sdk} />
        <InfoRow label="Signed" value={booleanValue(apkInfo.is_signed)} />
        <InfoRow label="Valid" value={booleanValue(apkInfo.valid_apk)} />
      </InfoTable>
    </div>
  );
};

export default APKInformationCard;
